<template>
  <identity-provider-form
    :errors="errors"
    :model="identity_provider"
    title="New Identity Provider"
    action="createIdentityProvider"
    @createIdentityProvider="createIdentityProvider"
  />
</template>

<script>
import IdentityProviderForm from './Form';

export default {
  components: {
    'identity-provider-form': IdentityProviderForm,
  },
  data() {
    return {
      identity_provider: {
        sign_metadata: true,
        authn_requests_signed: true,
        want_messages_signed: true,
      },
      errors: [],
    };
  },
  mounted() {
    this.$store.commit('setSelectedIdentityProviderId', undefined);
  },
  methods: {
    createIdentityProvider(identityProviderData) {
      this.$store
        .dispatch('createIdentityProvider', { ...identityProviderData })
        .then(
          (response) => {
            this.$store.commit('setIdentityProvider', response.data.data);
            this.$notify({
              group: 'general',
              type: 'success',
              title: 'Success',
              duration: 5000,
              text: 'Identity Provider successfully created.',
            });
            this.$store.dispatch('getIdentityProvider');
            this.$router.push({ name: 'saml-settings-view' });
          },
          () => {
            this.$notify({
              group: 'general',
              type: 'error',
              title: 'Error',
              duration: 5000,
              text: 'Could not save identity provider, please try again.',
            });
          },
        );
    },
  },
};
</script>
